import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import { useEffect } from 'react';
import MarketingCampaign from './MarketingCampaign';
import SalesCampaign from './SalesCampaign';

const PERSONA_CAMPAIGN_MAP: Record<string, React.ReactNode> = {
  maya: <SalesCampaign />,
  ron: <MarketingCampaign />,
};

function CampaignParent() {
  const { alchemystPersona, setStoreState } = useAlchemystStoreForAi((store) => ({
    alchemystPersona: store.alchemyst,
    setStoreState: store.setStoreState,
  }));

  // Clear campaign data when switching personas to ensure fresh fetch
  useEffect(() => {
    setStoreState({
      campaignWorkflows: [],
    });
  }, [alchemystPersona.persona]);

  return PERSONA_CAMPAIGN_MAP[alchemystPersona.persona];
}

export default CampaignParent;
